import React from 'react';

export const Home = (props) => (
  <svg
    fill="none"
    height="18"
    viewBox="0 0 17 18"
    width="17"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      className="home-icon-path"
      d="M8.17667 0.948864L0.656667 6.58906C0.561577 6.65924 0.502996 6.77637 0.503917 6.89457V17.0469C0.503936 17.2438 0.683043 17.4229 0.879917 17.4229H5.95592C6.15279 17.4229 6.3319 17.2438 6.33192 17.0469V11.0306H10.4679V17.0469C10.4679 17.2438 10.647 17.4229 10.8439 17.4229H15.9199C16.1168 17.4229 16.2959 17.2438 16.2959 17.0469V6.89457C16.2959 6.77637 16.2383 6.65924 16.1432 6.58906L8.62317 0.948864C8.45049 0.84757 8.32554 0.863963 8.17667 0.948864ZM8.39992 1.72441L15.5439 7.08257V16.6709H11.2199V10.6546C11.2199 10.4577 11.0408 10.2786 10.8439 10.2786H5.95592C5.75904 10.2786 5.57994 10.4577 5.57992 10.6546V16.6709H1.25592V7.08257L8.39992 1.72441Z"
      fill="#2F1359"
    />
  </svg>
);
